var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EModal',_vm._g(_vm._b({staticClass:"feedback-modal"},'EModal',_vm.$attrs,false),_vm.$listeners),[_c('EFeedbackForm',_vm._b({on:{"success":_vm.onSuccess}},'EFeedbackForm',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }